/**
 * חישוב ותצוגת כמות — משותף בין הלקוח (תצוגה חיה בעגלה) לשרת (מנוע
 * התמחור, TASKS 5.1 · PRD 7.4). מקור אמת יחיד לנוסחה, כדי שהכמות שהלקוח רואה
 * בעגלה תהיה **בדיוק** אותו מספר שהשרת מחשב להצעה.
 *
 * ⚠️ ⛔ אין כאן שום חישוב מחיר — רק כמות לתצוגה. המחיר עצמו נשאר בשרת
 *    בלבד (`server/src/lib/priceEngine.ts`), בדיוק כפי ש-PRD 7.4 מחייב.
 *
 * ⛔ **`per_sqm` (תמחור לפי מ"ר) הוסר כליל מהמודל — 20.08.2026, Feedback1.md
 *    סעיף 10.** "לא יהיה הצעה לפי אורך ורוחב" (טל). שני סוגי תמחור בלבד
 *    נשארים: `unit` ו-`per_meter`.
 */
/** עיגול כספי/מדידה ל-2 ספרות עשרוניות — עקבי עם `PricingFields.tsx` (התצוגה החיה הקיימת). */
export function round2(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
}
function formatNumber(n) {
    return n.toLocaleString('he-IL');
}
/**
 * תווית הכמות המוצגת בעגלה וב-PDF, לפי סוג התמחור (PRD 7.4 טבלת "תצוגה ב-PDF").
 * דוגמאות מאומתות: `"12 יח׳"` · `"2 × חבילה 50 מ'"`.
 *
 * ⚠️ `unit_label` הוא טקסט חופשי שטל מקליד בפאנל (PRD 7.4: "למשל 'חבילה 50 מ''
 *    עבור MG-0001") — **ביחיד**, ⛔ לא מנוסח לריבוי. `"{qty} {unitLabel}"`
 *    היה מייצר "2 חבילה 50 מ'" — עברית שגויה דקדוקית. `"{qty} × {unitLabel}"`
 *    נכון בכל כמות, בלי צורך בריבוי אוטומטי לטקסט חופשי בעברית.
 */
export function formatQuantityLabel(pricingType, measurements, unitLabel) {
    const { qty, lengthM } = measurements;
    if (pricingType === 'unit') {
        return unitLabel ? `${formatNumber(qty)} × ${unitLabel}` : `${formatNumber(qty)} יח׳`;
    }
    // per_meter
    const length = lengthM ?? 0;
    return qty > 1
        ? `${formatNumber(length)} מ' × ${formatNumber(qty)}`
        : `${formatNumber(length)} מ'`;
}
/** בונה את `quantityLabel` להצגה (עגלה או PDF) מתוך snapshot גולמי בלבד. */
export function buildLineDisplay(snapshot) {
    return {
        quantityLabel: formatQuantityLabel(snapshot.pricingType, snapshot, snapshot.unitLabel),
    };
}
//# sourceMappingURL=quantityLabel.js.map